var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-xs-6" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-6 trivia-reorder" }, [
      _c(
        "div",
        { staticClass: "reorder-list" },
        [
          _c(
            "draggable",
            {
              attrs: { disabled: _vm.questionAnswered },
              model: {
                value: _vm.orderedOptions,
                callback: function ($$v) {
                  _vm.orderedOptions = $$v
                },
                expression: "orderedOptions",
              },
            },
            _vm._l(_vm.orderedOptions, function (option, index) {
              return _c(
                "div",
                {
                  key: option.id,
                  staticClass: "reorder-item",
                  class: _vm.itemClass(option.id, index),
                },
                [
                  _c("span", { staticClass: "reorder-handle" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "10",
                          height: "16",
                          viewBox: "0 0 10 16",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: { cx: "2", cy: "2", r: "2", fill: "#A3B5C9" },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: { cx: "8", cy: "2", r: "2", fill: "#A3B5C9" },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: { cx: "2", cy: "8", r: "2", fill: "#A3B5C9" },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: { cx: "8", cy: "8", r: "2", fill: "#A3B5C9" },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: { cx: "2", cy: "14", r: "2", fill: "#A3B5C9" },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: { cx: "8", cy: "14", r: "2", fill: "#A3B5C9" },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "reorder-text",
                    domProps: { innerHTML: _vm._s(option.text) },
                  }),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.questionAnswered
            ? _c(
                "div",
                { staticClass: "trivia-result-indicator" },
                [
                  _vm.isCorrect
                    ? _c("check", { staticClass: "svg-icon large" })
                    : _c("incorrect", { staticClass: "svg-icon large" }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "reorder-submit" }, [
        !_vm.questionAnswered
          ? _c(
              "button",
              {
                staticClass: "btn primary-btn",
                on: {
                  click: function ($event) {
                    _vm.$emit(
                      "answer",
                      _vm.orderedOptions.map((o) => o.id)
                    )
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("CONTINUE")) +
                    "\n            "
                ),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }